export default "__VITE_ASSET__BVlCPgEN__"